import React from 'react';

interface CardProps {
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

interface CardContentProps {
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

interface CardFooterProps {
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

interface CardActionProps {
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

export const Card: React.FC<CardProps> = ({ style, children }) => {
  const baseStyles = {
    backgroundColor: '#ffffff',
    border: '1px solid #e5e7eb',
    borderRadius: '0.5rem',
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
    ...style,
  };

  return (
    <div style={baseStyles}>
      {children}
    </div>
  );
};

export const CardContent: React.FC<CardContentProps> = ({ style, children }) => {
  const baseStyles = {
    padding: '1.5rem',
    ...style,
  };

  return (
    <div style={baseStyles}>
      {children}
    </div>
  );
};

export const CardFooter: React.FC<CardFooterProps> = ({ style, children }) => {
  const baseStyles = {
    display: 'flex',
    alignItems: 'center',
    padding: '1.5rem',
    paddingTop: '0',
    ...style,
  };

  return (
    <div style={baseStyles}>
      {children}
    </div>
  );
};

export const CardAction: React.FC<CardActionProps> = ({ style, children }) => {
  const baseStyles = {
    paddingTop: '1rem',
    ...style,
  };

  return (
    <div style={baseStyles}>
      {children}
    </div>
  );
}; 